/** true en CRA dev; false en build de producción */
export function isDevEnvironment(): boolean {
  return process.env.NODE_ENV !== 'production';
}

export function devLog(...args: unknown[]): void {
  if (isDevEnvironment()) {
    console.log(...args);
  }
}

export function devWarn(...args: unknown[]): void {
  if (isDevEnvironment()) {
    console.warn(...args);
  }
}

/** Silencia console.log/debug/info en producción. Conserva warn y error. */
export function installProductionConsoleGate(): void {
  if (isDevEnvironment()) {
    return;
  }
  const noop = (): void => undefined;
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}
